import {
  ConsistencyRuleWidgetProps,
  EODTrailingLevelWidgetProps,
  PayoutWidgetProps,
  WidgetConfig,
  WidgetDataDependencies,
  WidgetType,
} from '../../types/widget-manager.types';
import { BaseWidgetStrategy } from './base-widget-strategy';

/**
 * Futures widget strategy
 * Returns: EODTrailingLevel, ConsistencyRule, Payout widgets
 */
export class FuturesWidgetStrategy extends BaseWidgetStrategy {
  getWidgetConfigs(data: WidgetDataDependencies): WidgetConfig[] {
    if (!this.validateData(data)) {
      return [];
    }

    const configs: WidgetConfig[] = [];

    // EOD Trailing Level widget (Futures-specific)
    configs.push({
      type: WidgetType.EODTrailingLevel,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      } as EODTrailingLevelWidgetProps,
      enabled: true,
      order: 1,
    });

    // Consistency Rule widget (Futures-specific)
    configs.push({
      type: WidgetType.ConsistencyRule,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      } as ConsistencyRuleWidgetProps,
      enabled: true,
      order: 2,
    });

    // Payout widget
    configs.push({
      type: WidgetType.Payout,
      props: {
        account: data.account,
        eligibilityData: data.eligibilityData,
      } as PayoutWidgetProps,
      enabled: true,
      order: 3,
    });

    // Sort by order and filter valid configs
    return this.filterValidConfigs(configs).sort((a, b) => {
      const orderA = a.order ?? 999;
      const orderB = b.order ?? 999;
      return orderA - orderB;
    });
  }
}
